<template>
  <v-btn
    @click="$emit('click')"
    class="remove-past-employer"
    large
    icon>
    <v-icon>delete</v-icon>
  </v-btn>
</template>

<script>
export default {};
</script>

<style>
</style>
